// extracted by mini-css-extract-plugin
export default {"reportCard":"U6PNp","reportCardItem":"m3bis","iconContainer":"ELMOe","textContent":"_7NJLU","heading":"yINpr","description":"JWgZU"};